import React from 'react';
import { useIntl } from 'react-intl';
import { faLock } from '@fortawesome/pro-light-svg-icons/faLock';
import { faArrowDownToLine } from '@fortawesome/pro-light-svg-icons/faArrowDownToLine';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../common/views/SMLButton/SMLButton';
import { useExportFans } from './useExportFans';
import { fansMessages as messages } from './fansMessages';

interface FansExportButtonProps {
  accountId: number;
}

/** "Download CSV" in the page head. With a lock on Free: a click opens the plan prompt (design c6). */
const FansExportButtonComponent: React.FC<FansExportButtonProps> = ({ accountId }) => {
  const intl = useIntl();
  const { exportFans, isExporting, isLocked } = useExportFans(accountId);

  return (
    <SMLButton
      size="sm"
      outline
      omitCap
      leftIcon={isLocked ? faLock : faArrowDownToLine}
      isLoading={isExporting}
      onClick={exportFans}
      testID="fans-export"
    >
      {intl.formatMessage(messages.exportCsv)}
    </SMLButton>
  );
};

export const FansExportButton = TypedMemo(FansExportButtonComponent);
